// extracted by mini-css-extract-plugin
module.exports = {"slideWrapper":"Bn","imageWrapper":"Bo","image":"Bp","imageInCenter":"Bq","ctaWrapper":"Br","copyright":"Bs","rentalBadge":"Bt","sideGradient":"Bu","bottomGradient":"Bv"};